<template>
  <section>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
      <el-table-column prop="Id" label="Id" width="180"></el-table-column>
      <el-table-column
        prop="Name"
        label="会员卡名称"
        width="180"
      ></el-table-column>
      <el-table-column prop="Price" label="会员卡价格"></el-table-column>
      <el-table-column prop="CardType" label="会员卡类型"></el-table-column>
      <el-table-column prop="AvailableCount" label="可用次数"></el-table-column>
      <el-table-column prop="AvailableDay" label="可用天数"></el-table-column>
      <el-table-column prop="VenueName" label="场馆"></el-table-column>
      <el-table-column
        prop="Instructions"
        label="须知"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
      <el-table-column
        prop="Detail"
        label="详情"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="会员卡名称" prop="Name">
              <el-input
                v-model="addForm.Name"
                placeholder="请输入会员卡名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员卡价格" prop="Price">
              <el-input-number
                v-model="addForm.Price"
                :min="0"
                :step="0.01"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="会员卡类型" prop="CardType">
              <el-input
                v-model="addForm.CardType"
                placeholder="请输入会员卡类型"
              ></el-input>
            </el-form-item>
            <el-form-item label="场馆" prop="VenueId">
              <el-select
                v-model="addForm.VenueName"
                value-key="Name"
                @change="getAddVenue"
              >
                <el-option
                  v-for="item in venueList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="封面图片" prop="CroverImage">
              <Upload
                @upload="coverUpload"
                @delete="coverDelete"
                type="match"
              ></Upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用次数" prop="AvailableCount">
              <el-input-number
                v-model="addForm.AvailableCount"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="可用天数" prop="AvailableDay">
              <el-input-number
                v-model="addForm.AvailableDay"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="须知" prop="Instructions">
              <el-input
                v-model="addForm.Instructions"
                type="textarea"
                :rows="3"
                placeholder="请输入须知"
              ></el-input>
            </el-form-item>
            <el-form-item label="详情" prop="Detail">
              <el-input
                v-model="addForm.Detail"
                type="textarea"
                :rows="3"
                placeholder="请输入详情"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="会员卡名称" prop="Name">
              <el-input
                v-model="editForm.Name"
                placeholder="请输入会员卡名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员卡价格" prop="Price">
              <el-input-number
                v-model="editForm.Price"
                :min="0"
                :step="0.01"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="会员卡类型" prop="CardType">
              <el-input
                v-model="editForm.CardType"
                placeholder="请输入会员卡类型"
              ></el-input>
            </el-form-item>
            <el-form-item label="场馆" prop="VenueId">
              <el-select
                v-model="editForm.VenueName"
                value-key="Name"
                @change="getEditVenue"
              >
                <el-option
                  v-for="item in venueList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="封面图片" prop="CroverImage">
              <Upload
                @upload="coverEditUpload"
                @delete="coverEditDelete"
                type="match"
                :fileUrl="editForm.CroverImage"
              ></Upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用次数" prop="AvailableCount">
              <el-input-number
                v-model="editForm.AvailableCount"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="可用天数" prop="AvailableDay">
              <el-input-number
                v-model="editForm.AvailableDay"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="须知" prop="Instructions">
              <el-input
                v-model="editForm.Instructions"
                type="textarea"
                :rows="3"
                placeholder="请输入须知"
              ></el-input>
            </el-form-item>
            <el-form-item label="详情" prop="Detail">
              <el-input
                v-model="editForm.Detail"
                type="textarea"
                :rows="3"
                placeholder="请输入详情"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  memberCardList,
  addMemberCard,
  deleteMemberCard,
  updateMemberCard,
} from "@/api/memberCard/memberCard";
import { getStadiumData } from "@/api/stadium/stadium";
import Upload from "@/components/Upload.vue";
export default {
  components: { Toolbar, Upload },
  data() {
    return {
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      venueList: [],
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getStadium();
  },
  methods: {
    handleEdit(row) {
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteMemberCard({ Id: row.Id }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
      });
    },
    addSubmit() {
      this.addLoading = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          addMemberCard(this.addForm)
            .then((res) => {
              this.addLoading = false;
              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.initPage();
                this.getList();
              }
            })
            .catch(() => {
              this.addLoading = false;
            });
        }
      });
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          updateMemberCard(this.editForm)
            .then((res) => {
              this.editLoading = false;
              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.initPage();
                this.getList();
              }
            })
            .catch(() => {
              this.editLoading = false;
            });
        }
      });
    },
    getAddVenue(e) {
      this.addForm.VenueId = e.Id;
      this.addForm.VenueName = e.Name;
    },
    getEditVenue(e) {
      this.editForm.VenueId = e.Id;
      this.editForm.VenueName = e.Name;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    coverEditUpload(e) {
      this.editForm.CroverImage = e;
    },
    coverEditDelete() {
      this.editForm.CroverImage = "";
    },
    coverUpload(e) {
      this.addForm.CroverImage = e;
    },
    coverDelete() {
      this.addForm.CroverImage = "";
    },
    getStadium() {
      getStadiumData().then((res) => {
        this.venueList = res.data.response;
      });
    },
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
    },
    initPage() {
      this.page = {
        currentPage: 1,
        pageSize: 10,
      };
      this.filters = {
        name: "",
      };
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
      };
      memberCardList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
  },
};
</script>